import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import fultonMarket__asset from "@/assets/restore/locations/chicago-fulton-market.jpg.asset.json";
import hancock__asset from "@/assets/restore/locations/chicago-hancock.jpg.asset.json";
import lincolnPark__asset from "@/assets/restore/locations/chicago-lincoln-park.jpg.asset.json";
import deerfield__asset from "@/assets/restore/locations/deerfield.jpg.asset.json";
import lakeForest__asset from "@/assets/restore/locations/lake-forest.jpg.asset.json";
import oakBrook__asset from "@/assets/restore/locations/oak-brook.jpg.asset.json";
import orlandPark__asset from "@/assets/restore/locations/orland-park.jpg.asset.json";
import schaumburg__asset from "@/assets/restore/locations/schaumburg.jpg.asset.json";
import stCharles__asset from "@/assets/restore/locations/st-charles.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Chicago – Fulton Market",
    address: "159 N Sangamon St, Suite 200",
    img: fultonMarket__asset.url,
    mapUrl: map("159 N Sangamon St Chicago IL"),
    to: "/locations/restore-chicago/",
  },
  {
    name: "Chicago – Hancock Center",
    address: "875 North Michigan Avenue, 31st Floor",
    img: hancock__asset.url,
    mapUrl: map("875 North Michigan Avenue Chicago IL"),
    to: "/locations/restore-chicago/",
  },
  {
    name: "Chicago Lincoln Park",
    address: "939 W. North Avenue, Suite 750",
    img: lincolnPark__asset.url,
    mapUrl: map("939 W North Avenue Chicago IL"),
    to: "/locations/restore-chicago/",
  },
  {
    name: "Deerfield",
    address: "500 Lake Cook Road, Suite #350",
    img: deerfield__asset.url,
    mapUrl: map("500 Lake Cook Road Deerfield IL"),
    to: "/locations/restore-chicago/",
  },
  {
    name: "Lake Forest",
    address: "100 S. Saunders Rd, Suite 150",
    img: lakeForest__asset.url,
    mapUrl: map("100 S Saunders Rd Lake Forest IL"),
    to: "/locations/restore-chicago/",
  },
  {
    name: "Oak Brook",
    address: "15255 S 94th Ave, 5th floor",
    img: oakBrook__asset.url,
    mapUrl: map("Oak Brook IL"),
    to: "/locations/restore-chicago/",
  },
  {
    name: "Orland Park",
    address: "15255 S 94th Ave, 5th floor",
    img: orlandPark__asset.url,
    mapUrl: map("15255 S 94th Ave Orland Park IL"),
    to: "/locations/restore-chicago/",
  },
  {
    name: "Schaumburg",
    address: "10 N. Martingale Rd, Suite 400",
    img: schaumburg__asset.url,
    mapUrl: map("10 N Martingale Rd Schaumburg IL"),
    to: "/locations/restore-chicago/",
  },
  {
    name: "St. Charles",
    address: "100 Illinois St, Suite 200",
    img: stCharles__asset.url,
    mapUrl: map("100 Illinois St St Charles IL"),
    to: "/locations/restore-chicago/",
  },
];

export const Route = createFileRoute("/locations/illinois/")({
  head: () => ({
    meta: [
      { title: "RESTORE Hair | Illinois Hair Transplants + Hair Restoration" },
      {
        name: "description",
        content:
          "Get your hair back and RESTORE your confidence in Illinois with RESTORE Hair Transplants, offering FUE & No Shave Hair Restoration. Get a free consult today!",
      },
      { property: "og:title", content: "Illinois Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair locations across Illinois and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/illinois/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/illinois/" }],
  }),
  component: () => <StateLocationsHub stateName="Illinois" h1="Illinois Hair Transplants" cities={cities} />,
});